import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../helpers';
import { store } from '../../../../store/store';
import { Provider } from 'react-redux';
import PasswordResetRequest from './PasswordResetRequest';

loadDOMComponent({
	selector: 'react-password-reset-request',
	callback: ({ container, context }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<PasswordResetRequest />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
